import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { CheckboxComponent } from 'app/modules/survey/survey-viewer/survey-question/types/checkbox/checkbox.component'
import { ICheckbox } from 'app/interfaces/ICheckbox'
import { CheckboxMatrix } from 'app/models/questions/CheckboxMatrix'

export class Checkbox extends CheckboxMatrix implements ICheckbox {

  constructor(question) {
    super(question)
  }

  getDisplayComponent() {
    return new QuestionComponent(CheckboxComponent, this)
  }
}
